import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "upload-header d-flex mb-2" }
const _hoisted_3 = { class: "d-inline me-auto" }
const _hoisted_4 = {
  key: 0,
  class: "upload-document"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary border border-primary"
}, "Add Documents", -1 /* HOISTED */)
const _hoisted_6 = { class: "upload-filters" }
const _hoisted_7 = { class: "upload-body" }
const _hoisted_8 = {
  key: 0,
  class: "new-documents"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "table table-responsive-md borderless" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("Type "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_12 = { class: "upload-footer pb-2 d-flex align-items-center justify-content-end" }
const _hoisted_13 = { class: "more-files-wrapper me-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", { href: "javascript:void(0);" }, "Add Another Document", -1 /* HOISTED */)
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
  /*#__PURE__*/_createTextVNode(" Uploading")
], -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "table table-responsive-md borderless" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Last Modified"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-8" })
], -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-6" })
], -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-6" })
], -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-4" })
], -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 0,
  class: "text-end"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }),
  /*#__PURE__*/_createTextVNode(" Delete")
], -1 /* HOISTED */)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye" }, null, -1 /* HOISTED */)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 1,
  class: "text-default"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading block-size-4" }, null, -1 /* HOISTED */)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 2,
  class: "d-flex justify-content-end"
}
const _hoisted_43 = { class: "btn-group table-btn-group my-auto" }
const _hoisted_44 = ["id"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h" }, null, -1 /* HOISTED */)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["ria-labelledby"]
const _hoisted_48 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddDocumentRow = _resolveComponent("AddDocumentRow")!
  const _component_TableEmpty = _resolveComponent("TableEmpty")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.title), 1 /* TEXT */),
      (_ctx.fileDetails.length <= 0 && _ctx.addPatientDocumentsPermission && !_ctx.isHistoryPage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadFilesChanged($event))),
              class: "file-input",
              multiple: ""
            }, null, 32 /* HYDRATE_EVENTS */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "document-filters")
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.fileDetails.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (!_ctx.uploading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _hoisted_11,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileDetails, (fileDetail, index) => {
                      return (_openBlock(), _createElementBlock("tbody", null, [
                        _createVNode(_component_AddDocumentRow, {
                          "file-detail": fileDetail,
                          "get-file-icon": _ctx.getFileIcon,
                          uploading: _ctx.uploading,
                          "searched-types": _ctx.searchedTypes,
                          "file-index": index,
                          "is-field-required": _ctx.isFieldRequired,
                          onRemoveFile: ($event: any) => (_ctx.removeFile(index))
                        }, null, 8 /* PROPS */, ["file-detail", "get-file-icon", "uploading", "searched-types", "file-index", "is-field-required", "onRemoveFile"])
                      ]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("footer", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("input", {
                        type: "file",
                        class: "file-input",
                        multiple: "",
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moreFilesAdded($event))),
                        disabled: _ctx.uploading
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15)
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-xs btn-primary me-2",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadDocuments())),
                      disabled: _ctx.uploading
                    }, " Save Documents ", 8 /* PROPS */, _hoisted_16),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-xs btn-outline-primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removeAllFiles())),
                      disabled: _ctx.uploading
                    }, " Cancel ", 8 /* PROPS */, _hoisted_17)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("table", _hoisted_21, [
        _hoisted_22,
        (!_ctx.patientDocuments.length && !_ctx.loadingDocuments)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
              _createVNode(_component_TableEmpty, {
                "col-span": 5,
                component: "documents",
                "secondary-message": "No Documents Found"
              })
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_24, [
              (_ctx.loadingDocuments)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                    return (_openBlock(), _createElementBlock("tr", null, _hoisted_29))
                  }), 256 /* UNKEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!_ctx.loadingDocuments)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.patientDocuments as any, (document) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("i", {
                          class: _normalizeClass(`file-icon far fa-file ${_ctx.getFileIcon(document.mimeType)} me-2`)
                        }, null, 2 /* CLASS */),
                        _createElementVNode("a", {
                          href: document.url,
                          target: "_blank"
                        }, _toDisplayString(document.documentName), 9 /* TEXT, PROPS */, _hoisted_30)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(document.uploadType), 1 /* TEXT */),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(document.modifiedOn)), 1 /* TEXT */),
                      (!_ctx.isHistoryPage)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                            (_ctx.deletePatientDocumentsPermission)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (!document.hasOwnProperty('IsPatientChart'))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn-xs btn-outline-danger icon-del",
                                        onClick: ($event: any) => (_ctx.deleteSelectedDocument(document.id))
                                      }, _hoisted_34, 8 /* PROPS */, _hoisted_32))
                                    : _createCommentVNode("v-if", true),
                                  (document.isPatientChart && document.Status != 4 && document.Status != 'Running')
                                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "btn table-btn btn-outline-info au-target",
                                        onClick: ($event: any) => (_ctx.openSelectedDocument(document))
                                      }, _hoisted_37, 8 /* PROPS */, _hoisted_35)), [
                                        [_directive_tooltip, { title: 'View' }]
                                      ])
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_openBlock(), _createElementBlock("i", _hoisted_38, "No Actions"))
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isHistoryPage && _ctx.isLoadingComment)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_39, _hoisted_41))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isHistoryPage && !_ctx.isLoadingComment)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn px-1 py-0 btn-outline-primary dropdown-toggle",
                                "data-bs-toggle": "dropdown",
                                id: `document__Actions${document.id}`
                              }, _hoisted_46, 8 /* PROPS */, _hoisted_44),
                              _createElementVNode("div", {
                                class: "dropdown-menu",
                                "ria-labelledby": `document__Action${document.id}`
                              }, [
                                (_ctx.deletePatientDocumentsPermission)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "dropdown-item text-danger",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.deleteSelectedDocument(document.id))
                                    }, " Delete ", 8 /* PROPS */, _hoisted_48))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: "javascript:void(0);",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createComment()))
                                }, " Comment ")
                              ], 8 /* PROPS */, _hoisted_47)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]))
      ])
    ])
  ]))
}